import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import {
  Modal,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  Heading,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { remove } from '@/modules/wealth/services/portfolio';
import { useRouter } from 'vue-router/composables';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeletePortfolioModal',
  props: {
  isOpen: { type: Boolean, default: false },
  portfolioId: { type: String, required: true }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props

const isAllowedToDeletePortfolio = ref(true);
const router = useRouter();

async function deletePortfolio() {
  try {
    await remove(props.portfolioId);
    router.push({ name: 'wealth' });
  } catch (error) {
    isAllowedToDeletePortfolio.value = false;
    console.error(error);
  }
}





const title = computed(() => {
  return isAllowedToDeletePortfolio.value
    ? 'Deseja excluir sua Carteira?'
    : 'Não é possível concluir esta ação no momento.';
});

const description = computed(() => {
  return isAllowedToDeletePortfolio.value
    ? 'Não será possivel reverter esta ação.'
    : 'Carteiras com saldo ou transações em processamento não podem ser excluídas.';
});

const buttonPrimaryLabel = computed(() => {
  return isAllowedToDeletePortfolio.value ? 'Excluir' : 'Fechar';
});

const buttonPrimaryClick = () => {
  isAllowedToDeletePortfolio.value === true ? deletePortfolio() : emit('close');
};

return { __sfc: true,isAllowedToDeletePortfolio, router, deletePortfolio, props, emit, title, description, buttonPrimaryLabel, buttonPrimaryClick, Modal, ButtonContainer, ButtonPrimary, ButtonSecondary, Heading, BaseText, NebraskaColors }
}

})